import { Component, Inject, Input } from '@angular/core';

import { EntityCheckboxListComponent } from '../../../../shared/checkbox-list/components/entity-checkbox-list.component';

import { ParcService } from '../services/parc.service';
import { ParcTLR } from '../entities/parc-tlr.entity';

@Component({
	selector: 'parc-checkbox-list',
	templateUrl: '../../../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class ParcCheckboxListComponent extends EntityCheckboxListComponent<ParcTLR> {
	_antenneIds: number[] = [];
	@Input() set antenneIds(ids: number[] | undefined) {
		if (ids != undefined && ids != this._antenneIds) {
			this._antenneIds = ids;
			this.updateParcs();
		}
	}
	get antenneIds(): number[] | undefined {
		return this._antenneIds;
	}
	
	// Label du champ
	override label = "Parc(s)"

	// Fonction determinant le label d'un parc
	override getEntityLabel = (parc: ParcTLR) => parc.code + " (" + parc.description + ")";

	constructor( //
		@Inject(ParcService) private parcService: ParcService //
	) {
		super();
	}
	
	private updateParcs() {
		if (this._antenneIds && this._antenneIds.length > 0) {
			this.parcService.getParcTLRMapByAntenne().subscribe(
				(map: Map<number, ParcTLR[]>) => {
					let parcs: ParcTLR[] = [];
					for (let i = 0; i <= this._antenneIds.length; i++) {
						let antenneId = this._antenneIds[i];
						let list = map.get(antenneId);
						if (list) {
							parcs = parcs.concat(list);
						}
					}

					// Trier ensuite tous les parcs par leur code
					parcs.sort(
						(p1, p2) => p1.code.localeCompare(p2.code) 
					);

					this.entities = parcs;
				}
			);
		} else {
			this.entities = [];
		}
	}
}